import classNames from 'classnames';
import { Component } from 'react';

import FormError from './FormError';

class TextField extends Component {
  // This isn't a pure function because focusing on a form field requires a ref (search code base for withRef)
  render() {
    const {
      input,
      label,
      meta: { touched, error },
      formType = 'text',
      refField,
      className,
      labelClassName,
      placeholder,
      labelPosition = 'before',
      actionButton,
      autocomplete,
      required
    } = this.props;
    const id = `c7-${input.name}`;
    let describedBy;
    if (touched && error) {
      describedBy = {
        'aria-describedby': `${id}-error`,
        'aria-invalid': 'true'
      };
    }
    return (
      <div className={classNames(className, touched && error && 'c7-error')}>
        <label className={labelClassName} htmlFor={`c7-${input.name}`}>
          {labelPosition === 'before' && renderLabel(label, required)}
          <input
            type={formType}
            id={id}
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...input}
            ref={refField}
            placeholder={placeholder}
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...describedBy}
            autoComplete={autocomplete}
          />
          {labelPosition === 'after' && renderLabel(label, required)}
        </label>
        {actionButton}
        <FormError touched={touched} error={error} id={`${id}-error`} />
      </div>
    );
  }
}

const renderLabel = (label, required) => (
  <>
    {/* required && '*' */}
    {label} {!required && <span className="c7-optional">(optional)</span>}
  </>
);

export default TextField;
